module.exports = __webpack_public_path__ + "src/routes/solution/img3.png?dead44f0";


//////////////////
// WEBPACK FOOTER
// ./src/routes/solution/img3.png
// module id = 2872
// module chunks = 1